/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const StageIcon = ({ width = 24, height = 24, hidden = false, title = 'Stage' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path d="M8 27v-9a21.309 21.309 0 0 0 8-16H3a1 1 0 0 0-1 1v25h5a1 1 0 0 0 1-1Z" />
    <path
      d="M25.637 30V16.042l.875-.875a3.617 3.617 0 1 0-2.027-2.113l-8.556 8.875a.732.732 0 0 0 0 1.036L16.965 24A.732.732 0 0 0 18 24l4.707-5.029V30H2v3a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1v-3Z"
    />
  </svg>`;
};
